import httpService from '@/api/httpService'

const UserApi = (() => {
  const apiPostfix = 'user'

  return {
    apiPostfix: apiPostfix,

    async getCurrentUser () {
      const response = await httpService.get(`${apiPostfix}/me`)
      return response.data
    },

    async saveCurrentUser (payload) {
      const response = await httpService.post(`${apiPostfix}/save`, payload)
      return response.data
    },

    async validateField (payload) {
      const response = await httpService.post(`${apiPostfix}/validateField`, payload)
      return response.data
    },

    async changePassword (payload) {
      const response = await httpService.post(`${apiPostfix}/changePassword`, payload)
      return response.data
    },
    async entities () {
      const response = await httpService.get(`${apiPostfix}/entities`)
      return response.data
    }
  }
})()

export default UserApi
